import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import CreateSingleStateExams from "./Create";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "state-exams-single",
  title: "Създаване на единичен държавен изпит",
  create: <CreateSingleStateExams />,
  permission: permissions.canCreateSingleStateExam,
};
